import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello, I am <span className="purple">Ethan Johnson </span>
            from <span className="purple"> Toronto, Canada.</span>
            <br />I am a Full stack engineer.
            <br />
            <br />
            Apart from programming, some other activities that I love to do are: 
          </p>
          <ul>
            <li className="about-activity">
              👾 Playing Games
            </li>
            <li className="about-activity">
              ✏️ Learning new skills
            </li>
            <li className="about-activity">
              ✈️ Traveling
            </li>
            <li className="about-activity">
              💪 Going to the gym
            </li>
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
